export default __webpack_public_path__ + "images/warning-red.svg";